<template>
    <svg class='svg svg--icon svg--caret svg--caret--down' width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M8 4C10.449 4 13.3317 4 16 4C13.3341 4 8 10.6667 8 14C8 10.6667 2.66826 4 1.45548e-08 4C2.66587 4 5.55102 4 8 4Z' class='svg__fill' vector-effect='non-scaling-stroke' />
    </svg>
</template>